module.exports = "/static-assets/feed-ui/_next/static/images/ogImg-fe7540d52d580503859a5d5248bc4bce.png";